<div class="scrim" [class.visible]="sidebar.mobileOpen()" (click)="sidebar.closeMobile()"></div>

<aside class="hc-sidebar"
       [class.collapsed]="sidebar.collapsed()"
       [class.mobile-open]="sidebar.mobileOpen()">
  <div class="sidebar-scroll">

    @if (!isBelowThreshold && !isContextMenu()) {
      <div class="collapse-row">
        <button type="button" class="collapse-btn" (click)="sidebar.toggleCollapse()"
                [title]="(sidebar.collapsed() ? 'navigation.menu.expand' : 'navigation.menu.collapse') | translate">
          <i class="fa" [ngClass]="sidebar.collapsed() ? 'fa-indent' : 'fa-outdent'" aria-hidden="true"></i>
        </button>
      </div>
    }

    <mat-tree #tree [dataSource]="menu" [childrenAccessor]="childrenAccessor" class="nav-tree">

      <!-- Divider node -->
      <mat-tree-node *matTreeNodeDef="let node; when: isDivider">
        <hr class="nav-divider" />
      </mat-tree-node>

      <!-- Label node -->
      <mat-tree-node *matTreeNodeDef="let node; when: isLabel">
        <div class="nav-label" [title]="node.labelKey | translate">{{ node.labelKey | translate }}</div>
      </mat-tree-node>

      <!-- Leaf node -->
      <mat-tree-node *matTreeNodeDef="let node; let level = level">
        <a class="nav-item"
           [ngClass]="[node.style || '', node.isDanger ? 'danger' : '']"
           [class.active]="isActive(node)"
           [style.padding-left.px]="sidebar.collapsed() ? null : (level * 30) + 12"
           [title]="('navigation.' + node.name) | translate"
           (click)="onNodeClick(node)">
          <span class="chevron-placeholder"></span>
          <img class="nav-ico" [src]="node.image" width="25" height="25" alt="" />
          <span class="nav-text">{{ ('navigation.' + node.name) | translate }}</span>
        </a>
      </mat-tree-node>

      <!-- Expandable node -->
      <mat-tree-node *matTreeNodeDef="let node; when: hasChild; let level = level"
                     [cdkTreeNodeTypeaheadLabel]="node.name">
        <a class="nav-item"
           [ngClass]="node.style || ''"
           [class.active]="!tree.isExpanded(node) && isChildActive(node)"
           [style.padding-left.px]="sidebar.collapsed() ? null : (level * 30) + 12"
           [title]="('navigation.' + node.name) | translate"
           matTreeNodeToggle
           [attr.aria-label]="'Toggle ' + node.name">
          <mat-icon class="nav-chevron">
            {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
          <img class="nav-ico" [src]="node.image" width="25" height="25" alt="" />
          <span class="nav-text">{{ ('navigation.' + node.name) | translate }}</span>
        </a>
      </mat-tree-node>

    </mat-tree>
  </div>
</aside>
